<template>
    <div class="main">
        <component :is="type" :id="id" :title="title"></component>
    </div>
</template>

<script>
    import ShopTask from './components/task/ShopTask';
    import LastTask from './components/task/LastTask';
    import TransportTask from './components/task/TransportTask';
    import ElasticTask from './components/task/ElasticTask';
    import WaitTask from './components/task/WaitTask';
    import WaitOtherTask from './components/task/WaitOtherTask';
    import PayTask from "./components/task/PayTask";

    export default {
        name: 'Task',
        components: {
            'shop': ShopTask,
            'last': LastTask,
            'transport': TransportTask,
            'elastic': ElasticTask,
            'wait': WaitTask,
            'wait-other': WaitOtherTask,
            'pay': PayTask,
            'accompanying': ElasticTask,
            'housekeeping': ElasticTask,
        },
        data() {
            return {
                id: null,
                type: null,
                title: '地址',
            }
        },
        created() {
            this.type = this.$route.params.type;
            this.id = this.$route.params.id;
            this.title = this.$route.params.title || '地址';
        }
    };
</script>

<style scoped>
    .main {
        min-height: 100%;
        position: relative;
        flex: 1;
    }
</style>
